// extracted by mini-css-extract-plugin
module.exports = {"container":"WithFocusRing_container__rHD30","showFocusRing":"WithFocusRing_showFocusRing__zGALK"};